import { createAxiosInstance } from './http';

export const login = async (data) => {
  const res = await createAxiosInstance().post('/auth/login', data);
  return res.data;
};

export const register = async (data) => {
  const res = await createAxiosInstance().post('/auth/register', data);
  return res.data;
};

export const forgotPassword = async (data) => {
  const res = await createAxiosInstance().post('/auth/forgot-password', data);
  return res.data;
};

